import { defineMessage } from 'react-intl';

// Global app defaults
export const DEFAULT_LOCALE = 'en-US';

export const DEFAULT_CURRENCY = 'USD';

export const DEFAULT_SITE_TITLE = 'Sur La Table';

export const DEFAULT_TIME_ZONE = 'America/New_York';

export const MAX_CACHE_AGE = 60 * 15; // 15 min

// Constants used in the used for product searching.
export const DEFAULT_SEARCH_PARAMS = { limit: 25, offset: 0, sort: 'best-matches', refine: [] };
export const DEFAULT_LIMIT_VALUES = [25, 50, 100]; // Page sizes

// Constants for Search Component
export const RECENT_SEARCH_LIMIT = 5;
export const RECENT_SEARCH_KEY = 'recent-search-key';
export const RECENT_SEARCH_MIN_LENGTH = 3;

// Constants for the Homepage's Shop Products section.
export const HOME_SHOP_PRODUCTS_CATEGORY_ID = 'newarrivals';
export const HOME_SHOP_PRODUCTS_LIMIT = 10;

// Constants for menu
export const CAT_MENU_DEFAULT_NAV_DEPTH = 3;
export const CAT_MENU_DEFAULT_ROOT_CATEGORY = 'root';
export const CAT_MENU_STALE_TIME = 10000; // 10 seconds

export const cssColorGroups = {
    beige: '#d3bca9',
    black: '#000000',
    blue: '#4089c0',
    brown: '#8e6950',
    green: '#88c290',
    grey: '#919191',
    gray: '#919191',
    silver: '#c0c0c0',
    navy: '#000080',
    orange: '#f4995c',
    pink: '#f5a0ca',
    purple: '#9873b9',
    red: '#df5b5b',
    white: '#FFFFFFF',
    yellow: '#fbe85a',
    gold: '#ffd700',
    miscellaneous: 'linear-gradient(to right, orange , yellow, green, cyan, blue, violet)',
};

// Color to use for the UI surrounding the page in browsers.
export const THEME_COLOR = '#1A1A1A';

export const API_ERROR_MESSAGE = defineMessage({
    id: 'global.error.something_went_wrong',
    defaultMessage: 'Something went wrong. Try again!',
});

export const HOME_HREF = '/';

export const MAX_ORDER_QUANTITY = 10;

export const urlPartPositions = {
    PATH: 'path',
    QUERY_PARAM: 'query_param',
    NONE: 'none',
};

export const SCROLL_OPTIONS = {
    behavior: 'smooth',
    block: 'start',
} as ScrollIntoViewOptions;

export const SHIPPING_PROTECTION_PRODUCT_ID = 'SHIPPING_PROTECTION';

export const PERKS_MULTIPLIER = 1.25;
